import { FC } from 'react';
import { Alert } from './Alert';
import { AlertProps } from './model/AlertProps';

export const AlertWarning: FC<Omit<AlertProps, 'severity'>> = ({ ...props }) => <Alert severity="warning" {...props} />;
